<template>
  <div class="font-medium text-sm ml-2"
       :class="{'text-green': type === 'income',
                'text-red':   type === 'expense',
                'text-yellow':type === 'transfer'}"
       v-tooltip="valueTooltip">
    {{ valueDisplay }}
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import transactionCurrencyDisplayProp from "@/mixins/transactionCurrencyDisplayProp";

export default {
  name: "Value",
  mixins: [transactionCurrencyDisplayProp],
  props: {
    type: {
      type: String,
      required: true,
      validator: (val) => ['income', 'expense', 'transfer'].includes(val)
    },
    isExpense: {
      type: Boolean,
      required: true,
    },
    sum: {
      type: Number,
      required: true
    },
    sumBase: {
      type: Number,
    },
    currency: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    ...mapGetters('space', ['spaceInfo']),
    valueTooltip() {
      if (this.currencyDisplay === 'space_base') return '';
      let accountCurrencyIsDifferentFromSpace = this.currency.id !== this.spaceInfo.currency.id;
      if (accountCurrencyIsDifferentFromSpace && this.sumBase) {
        let displayBase = this.displayCurrencyValue(this.sumBase, this.spaceInfo.currency, true)
        return `${this.isExpense ? '-' : ''}${displayBase}`
      }
      return null
    },
    valueDisplay() {
      const displaySettings = {
        default: {
          sum: this.sum,
          currency: this.currency
        },
        space_base: {
          sum: this.sumBase,
          currency: this.spaceInfo.currency
        }
      };
      const {sum, currency} = displaySettings[this.currencyDisplay],
          displayedValue = this.displayCurrencyValue(sum, currency),
          prefixSign = this.isExpense ? '-' : '';
      return `${prefixSign}${displayedValue}`
    }
  }
}
</script>